import { component as defineComponent } from 'flightjs';
import withProfileImageUploader from 'mixins/with-profile-image-uploader';

function avatarUploader() {
    this.defaultAttrs({
        eventPrefix: 'uiAvatar',
        backupUrl: '',
        previewImageWidth: 250,

        originalImageSelector: '[data-avatar-image-display]',
        canvasSelector: '[data-avatar-image-preview-canvas]',
        uploaderSelector: '[data-avatar-uploader]',
        saveButtonSelector: '[data-avatar-image-save-button]',
        saveButtonInnerSelector: '[data-avatar-image-save-button-inner]',
        saveButtonLabelSelector: '[data-avatar-image-save-button-label]',
        cancelButtonSelector: '[data-avatar-image-cancel-button]',
        editButtonSelector: '[data-avatar-image-edit-button]',
        confirmEditWrapperSelector: '[data-avatar-image-confirm-edit]',
        errorMessageSelector: '[data-image-alert]',
        errorMessageBodySelector: '[data-image-alert-body]',
        uploaderTemplateSelector: '[data-avatar-uploader-template]',
    });

    this.after('initialize', function () {
        // UI interaction events
        this.on('click', {
            saveButtonSelector: this.uploadSelectedImage,
            cancelButtonSelector: this.cancelSelectedImage,
        });

        // Set preview image to DOM when canvas was drawn
        this.on('uiAvatarDrawnOnCanvas', this.setBackgroundUrl);

        // Image selected for preview
        this.on('uiAvatarSubmittedToUploader', this.drawThumbnailOnCanvas);
        this.on('uiAvatarSubmittedToUploader', this.showConfirmWrapper);
        this.on('uiAvatarSubmittedToUploader', this.showOverlay);

        // Image upload canceled (CANCEL buttons)
        this.on('uiAvatarUploadCanceled', this.setBackgroundUrl);
        this.on('uiAvatarUploadCanceled', this.hideConfirmWrapper);
        this.on('uiAvatarUploadCanceled', this.hideOverlay);

        // Image upload started (SAVE buttons)
        this.on('uiAvatarUploadStarted', this.disableSaveButton);
        this.on('uiAvatarUploadStarted', this.disableCancelButton);

        // Automatic image upload started (e.g. old browsers)
        this.on('uiAvatarAutomaticUploadStarted', this.disableEditButton);

        // Image upload complete
        this.on('uiAvatarUploadComplete', this.hideOverlay);
        this.on('uiAvatarUploadComplete', this.hideConfirmWrapper);
        this.on('uiAvatarUploadComplete', this.enableSaveButton);
        this.on('uiAvatarUploadComplete', this.enableCancelButton);
        this.on('uiAvatarUploadComplete', this.enableEditButton);
        this.on('uiAvatarUploadComplete', this.setBackgroundUrl);

        // Upload failed
        this.on('uiAvatarUploadFailed', this.showErrorMessage);
        this.on('uiAvatarUploadFailed', this.setBackgroundUrl);

        // Set backup url for orignal cover-image
        this.attr.backupUrl = this.select('originalImageSelector').attr('data-avatar-image-backup-url');

        // Initialize Fineuploader
        this.initializeUploader();
    });
}

export default defineComponent(avatarUploader, withProfileImageUploader);



// WEBPACK FOOTER //
// ./src/js/component_ui/avatar-uploader.js